export default __webpack_public_path__ + "static/media/Delicias.ed6aaeff.jpg";